import { Tag } from "~/models/list";
import { addBaseUrlToTags } from "~/utils/tags";
import { buildUrl } from "~/utils/url";
import { ItemDescription } from "~/common/list/ItemDescription";
import { ItemHeader } from "~/common/list/ItemHeader";
import { RatingBadge } from "~/common/charity/RatingBadge";
import { ListItemFooter } from "./ListItemFooter";

interface ListItemCardProps {
  baseUrl: string;
  listId: string;
  ein: string;
  name: string;
  rating?: number;
  starRating: number;
  city?: string;
  state?: string;
  tags?: Tag[];
  description?: string;
}

export function ListItemCard({
  baseUrl,
  listId,
  ein,
  name,
  rating,
  starRating,
  city,
  state,
  tags,
  description,
}: ListItemCardProps) {
  return (
    <div
      onClick={() => {
        window.location.href = buildUrl(baseUrl, `/ein/${ein}`);
      }}
      className="tw:min-w-[300px] tw:my-4 tw:md:my-0 tw:block tw:w-full tw:max-w-[400px] tw:bg-white tw:rounded-[20px] tw:lg:rounded-3xl tw:!border tw:!border-gray-300/60 tw:!shadow-[8px_8px_16px_0_rgba(166,171,189,0.1)] tw:p-5 tw:hover:cursor-pointer"
      aria-label="nonprofit profile page"
    >
      <div className="tw:flex tw:flex-col">
        <ItemHeader
          name={name}
          city={city}
          state={state}
          tags={addBaseUrlToTags(tags, baseUrl)}
        />

        <RatingBadge eligible={true} rating={rating} starRating={starRating} />

        <ItemDescription description={description} />
        <ListItemFooter
          listId={listId}
          name={name}
          ein={ein}
          isFavorite={false}
        />
      </div>
    </div>
  );
}
